import React, { useEffect, useMemo, useState } from 'react'
import "./SubTaskScreen.css";
import UpdatePageTopbar from '../UpdatePageTopbar/UpdatePageTopbar';
import UpdateTable from '../UpdateTable/UpdateTable';
import DocumentUpdate from '../../../../components/SVG/DocumentUpdate';
import FieldUpdate from '../../../../components/SVG/FieldUpdate';
import { Navigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleTask } from '../../../../redux/TaskReducer/action';
import { getSubtaskCountByType } from '../../../../utils/taskUtils';

const SubTaskScreen = () => {
    const { singleTask } = useSelector((store) => {
        return {
            singleTask: store.TasksReducer.singleTask
        }
    })

    const { taskId } = useParams();
    // const [subTaskType, setSubTaskType] = useState(null);
    const { subtaskTypeId } = useParams();
    // const [subtaskTypeCount, setSubtaskTypeCount] = useState(0);
    const [newSubTask, setNewSubTask] = useState({
        task_id: "",
        task_type_id: "",
        assigned_to: "",
        category_ids: [],
        priority_id: "",
        title: "",
        description: "",
        due_date: ""
    });

    const dispatch = useDispatch();

    useEffect(() => {
        setNewSubTask(prev => ({
            ...prev,
            task_id: taskId,
            task_type_id: Number(subtaskTypeId)
        }));

        dispatch(getSingleTask(taskId));

        // let count = getSubtaskCountByType(singleTask?.data?.sub_tasks);
        // console.log({count});
        // setSubtaskTypeCount(count[subtaskTypeId]);
    }, [taskId, subtaskTypeId]);

    // useEffect(() => {
    //     setNewSubTask(prev => ({
    //         ...prev,
    //         due_date: singleTask?.data?.due_date?.split('T')?.[0]
    //     }));
    // }, [singleTask]);

    // useEffect(() => {
    //     if (!singleTask?.data?.sub_tasks) return;

    //     let count = getSubtaskCountByType(singleTask?.data?.sub_tasks);
    //     setSubtaskTypeCount(count[subtaskTypeId] || 0);
    // }, [singleTask?.data?.sub_tasks, subtaskTypeId]);

    const subtaskTypeCount = useMemo(() => {
        if (!singleTask?.data?.sub_tasks) return 0;

        const count = getSubtaskCountByType(singleTask.data.sub_tasks);
        return count[subtaskTypeId] || 0;
    }, [singleTask?.data?.sub_tasks, subtaskTypeId]);

    console.log("Task ID:", taskId);

    if (!taskId) return <Navigate to="/task-management/dashboard" />;

    return (
        <div className='subtask-screen-container'>
            <UpdatePageTopbar
                componentName={`${subtaskTypeId == 1 ? "Document" : "Data"} Update`}
                newSubTask={newSubTask}
                setNewSubTask={setNewSubTask}
                // setSubTaskType={setSubTaskType}
                singleTask={singleTask}
            />

            {
                <div className='subtask-update-stat'>
                    <p>{`${subtaskTypeId == 1 ? "Document" : "Data"} Update: ${subtaskTypeCount}`}</p>
                    <div className='data-update-icon'>
                        {
                            subtaskTypeId == 1 ? 
                            <DocumentUpdate /> :
                            <FieldUpdate />
                        }
                    </div>
                </div>
            }


            <UpdateTable
                component={`${subtaskTypeId == 1 ? "Document" : "Data"} Update`}
                taskData={singleTask?.data?.sub_tasks || []}
                // fileData={fileData}
            />
        </div>
    )
}

export default SubTaskScreen